import styled from "@emotion/styled";

import { theme } from "shared/lib/styles";

export const Right = styled.div`
  margin-block-start: 20px;

  ${theme.breakpoints.up("tablet")} {
    margin-block-start: 40px;
  }
`;

export const Bio = styled.div`
  margin-block-start: 12px;

  ${theme.breakpoints.up("tablet")} {
    margin-block-start: 40px;
  }
`;

export const List = styled.div`
  margin-block-start: 20px;

  :not(:empty) {
    border-block-start: 1px solid #000000;
  }

  ${theme.breakpoints.up("tablet")} {
    margin-block-start: 40px;
  }
`;

export const Container = styled.div`
  display: grid;
  grid:
    "bio" min-content
    "list" min-content
    / 100%;
  grid-column-gap: 32px;

  inline-size: 100%;
  margin-block-end: 60px;

  ${theme.breakpoints.up("tablet")} {
    grid:
      "bio" min-content
      "list" min-content
      / 634px;
    place-content: center;
  }

  ${theme.breakpoints.up("desktop")} {
    grid:
      "header header" min-content
      "bio . " min-content
      "list right " 1fr
      / 634px 190px;
  }

  ${Right} {
    grid-area: right;

    display: none;
    place-self: start end;

    ${theme.breakpoints.up("desktop")} {
      display: block;
    }
  }

  ${Bio} {
    grid-area: bio;
  }

  ${List} {
    grid-area: list;
  }
`;
